import { z } from 'zod';

export const AUTOMAKER_GROUPS_STATUSES = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;

export const baseAutomakerGroup = z.object({
  id: z.string(),
  name: z.string(),
  status: z.enum(AUTOMAKER_GROUPS_STATUSES),
});
